import { render, staticRenderFns } from "./BrokerArea.vue?vue&type=template&id=44caf45e&"
import script from "./BrokerArea.vue?vue&type=script&lang=js&"
export * from "./BrokerArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports